import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../core/services/login.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { SystemInfoModel } from '../../core/models/classes/system-info';
import { DataService } from '../../core/services/data.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  about: SystemInfoModel;
  Version: string;
  constructor(private loginService: LoginService, public dialog: MatDialog, private dataService: DataService) { }

  ngOnInit(): void {
    this.Version = environment['appVersion'];
    this.dataService.getAboutStatus().subscribe({
      next: (data) => {
        this.about = data;        
        let newDt = this.formatDate(data.licenseValidity);
        this.about.licenseValidity = newDt;
        if(!this.about.name.length){
          this.about.name = "-";
        }
      },
    });    
  }

  formatDate(dt: string): string{
      let currentDt = dt.split('.');
      if(currentDt.length !== 3) 
      {
        return dt;
      }
      else{
        const [yr, mnt, day] = currentDt;
        var dt = `${day}.${mnt}.${yr}`;
        return dt;
      } 
            
  }
}
